import ContentConstants from '../contentConstants';
import { GroupType } from '../models';

// The bitwise 'AND' (&) operator can be used to determine if a flag value has been selected.
// The resulting value will end up being the same enum value if the flag is selected, or 0 if not.
// This is easier to picture when representing the numbers in binary e.g. 1111 & 0001 == 0001 vs 1110 & 0001 == 0000
// tslint:disable: no-bitwise
export const getGroupTypeFlagsAsArray = (value: GroupType) =>
	[GroupType.TheirGroupOnly, GroupType.TheirGroupAndAllBelow, GroupType.TheirRollupsOnly, GroupType.TheirRollupsAndAllBelow].filter(
		(g) => (value & g) === g,
	);
// tslint:enable: no-bitwise

const groupTypeLabels = {
	[GroupType.TheirGroupOnly]: ContentConstants.GROUPTYPE_THEIRGROUPONLY,
	[GroupType.TheirGroupAndAllBelow]: ContentConstants.GROUPTYPE_THEIRGROUPANDALLBELOW,
	[GroupType.TheirRollupsOnly]: ContentConstants.GROUPTYPE_THEIRROLLUPSONLY,
	[GroupType.TheirRollupsAndAllBelow]: ContentConstants.GROUPTYPE_THEIRROLLUPSANDALLBELOW,
};

export const getGroupTypeLabels = (value: GroupType) => getGroupTypeFlagsAsArray(value).map((g) => groupTypeLabels[g]);
